import useFetch from '@hooks/useFetch';
import { emptyList } from '@constants/empty';
import isEmpty from '@utils/isEmpty';
import { HOST_TYPE } from '@utils/api-helper/host';
import processPracticeTopologyData from '../../processors/practice';

const topologyMiddleware = (useSWRNext) => (key, fetcher, config) => {
  const swr = useSWRNext(key, fetcher, config);
  const hasNoData = isEmpty(swr.data);

  if (hasNoData) {
    return swr;
  }

  const isDataAnArray = Array.isArray(swr.data);
  const processedCourseData = isDataAnArray
    ? swr.data.map((item) => processPracticeTopologyData(item))
    : {
        ...swr.data,
        data: swr.data.map((item) => processPracticeTopologyData(item))
      };

  return {
    ...swr,
    data: processedCourseData
  };
};

export const getKey = (goalUID, subTopic) => {
  if (!goalUID) {
    return null;
  }

  let key = `v1/quizzes/topology/practice_session_seo_topologies/?parent_uid=${goalUID}`;

  if (subTopic) {
    key += '&topic_practice_section=True';
  }

  return key;
};

const usePracticeTopologies = (goalUID, options = {}, swrOptions = {}) => {
  const { subTopic = false } = options;
  const key = getKey(goalUID, subTopic);

  const { data: practiceTopologies, ...rest } = useFetch(
    key,
    { hostType: HOST_TYPE.BACKEND_API_HOST },
    {
      use: [topologyMiddleware],
      revalidateOnMount: false,
      ...swrOptions
    }
  );

  return {
    key,
    practiceTopologies: practiceTopologies || emptyList,
    ...rest
  };
};

export default usePracticeTopologies;
